/**
 * Braintree-related error codes.
 * - String values: FE-originated (e.g. init failure before BE response).
 * - Numeric values: BE response codes from racing-brt (tvg.errors.*.code).
 *   Used to compare with response.data.code and for UI message lookup (pawsErrorMessages).
 * User-facing copy for these codes will be mapped in TC-1045.
 */
export const BRAINTREE_ERROR_CODES = {
  // FE-originated (no BE response)
  INIT_ERROR: "BRAINTREE_INIT_ERROR",
  PAYMENT_ERROR: "BRAINTREE_PAYMENT_ERROR",
  /** PayPal tokenized nonce came back without a payer id (cannot finish deposit) */
  MISSING_PAYER_ID: "BRAINTREE_MISSING_PAYER_ID",
  /** Client-side validation in BRT CC API wrappers */
  MISSING_REQUIRED_PARAMS: "MISSING_REQUIRED_PARAMS",
  INVALID_AMOUNT: "INVALID_AMOUNT",

  // Access and authentication
  AUTHENTICATION: 159001,
  ACCESS_DENIED: 159002,

  // Illegal argument / validation (4xx)
  INVALID_REQUEST: 159400,
  METHOD_ARGUMENT_TYPE_MISMATCH: 159401,
  INVALID_PAYMENT_METHOD: 159402,
  INVALID_PAYMENT_TYPE: 159403,
  CALCULATING_FEE_ON_DATABASE: 159404,
  INVALID_DEPOSIT_AMOUNT: 159405,
  INVALID_DEPOSIT_ARGUMENT: 159406,
  VALIDATION_ERROR: 159407,
  DEPOSIT_TYPE_NOT_ALLOWED: 159408,
  NONCE_NOT_FOUND: 159409,
  INVALID_NONCE: 159410,
  MISSING_SERVLET_REQUEST_PARAMETER: 159411,
  METHOD_ARGUMENT_NOT_VALID: 159412,
  RESPONSIBLE_GAMING_LIMITS_EXCEEDED: 159413,
  RESPONSIBLE_GAMING_LIMITS_BELOW_MINIMUM: 159414,
  INSUFFICIENT_FUNDS: 159415,
  LIMIT_EXCEEDED: 159416,
  EXPIRED_CARD: 159417,
  INVALID_CREDIT_CARD_NUMBER: 159418,

  // Third-party / generic (5xx)
  BRAINTREE_EXCEPTION: 159500,
  GENERIC_PROCESSOR_RESPONSE_ERROR: 159501,
  OTHER: 159502,
  UNKNOWN_ERROR: 159503,
  MULTIPLE_TRANSACTIONS: 159504,

  // Custom deposit errors (7xx)
  DEPOSIT_FAILED: 159700,
  DEPOSIT_TIMEOUT: 159701,
  DEPOSIT_KAFKA: 159702,
  DEPOSIT_FEE_CALCULATION: 159703,
  PAYMENT_OPTION_NOT_FOUND: 159704,
  GET_USER_ACCOUNT_DETAILS: 159705
} as const;

/**
 * Poll interval while waiting for the Braintree JS SDK (`window.braintree`) to load.
 * Shared by `useBraintreeHostedFields` and `useBraintreeDataCollector`.
 */
export const BRAINTREE_SDK_SCRIPT_POLL_INTERVAL_MS = 200;

// Stop polling after this long if the Braintree SDK never appears
export const BRAINTREE_SDK_SCRIPT_LOAD_TIMEOUT_MS = 10_000;

export const PAYPAL_ERROR_CODES = {
  PAYMENT_ERROR: "PAYPAL_PAYMENT_ERROR"
} as const;
